export const getProductKey = (product: string, isComposite = false) => {
    return isComposite ? (product.includes('RAP') ? 'rap-composite' : 'pi-composite') : (product.includes('RAP') ? 'rap' : 'pi');
}

export const startFlagFromProduct = (product: string) => product.includes('RAP') ? 'Down' : 'Up';

export const endFlagFromProduct = (product: string) => product.includes('RAP') ? 'Up' : 'Down';
